import { render, staticRenderFns } from "./delivery_sub_units.vue?vue&type=template&id=4d15c188"
import script from "./delivery_sub_units.vue?vue&type=script&lang=js"
export * from "./delivery_sub_units.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports